import styled from 'styled-components';

export const StyledWrapper = styled.div`
    width: 100%;
    margin-bottom: 48px;
`;
